<ecp-hero title="Ship Frames to the lab" image="assets/images/headers/experts.jpg"> </ecp-hero>
<div class="container">
  <div class="row">
    <div class="col s12 is-flex is-fullwidth">
      <ecp-loader *ngIf="pageLoading" class="frame-loader"></ecp-loader>
      <mat-card *ngIf="frameToComeId">
        <div class="row">
          <div class="col m2 offset-m10"><button class="btn btn-primary" (click)="backToList()">Back To List</button></div>
        </div>
      </mat-card>
      <ecp-frame-to-search [frameToShipItems]="frameToShip" (orderDetails)="emitLoading($event)" [isFromDetails]="isFromDetails"></ecp-frame-to-search>
      <ecp-frame-to-ship [frameToShipItems]="frameToShip" [cartId]="cartId"></ecp-frame-to-ship>
    </div>
  </div>
</div>
